export function trimJsonStrings(obj: any): any {
  if (typeof obj === 'string') {
    return obj.trim();
  }

  if (Array.isArray(obj)) {
    return obj.map(trimJsonStrings);
  }

  if (obj !== null && typeof obj === 'object') {
    const trimmedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        trimmedObj[key] = trimJsonStrings(obj[key]);
      }
    }
    return trimmedObj;
  }

  // Return other types (numbers, booleans, null, etc.) as-is
  return obj;
}

export function isNullOrEmpty(object) {
    if (object === null || object.length === 0 || object == undefined) return true;
    return Object.keys(object).length === 0;
  }
